const doModesForLargeScreen = ({
  startzIndex,
  largeBeginWidth,
  largeScreenLargeBeginMidWidth,
  endFixedWidth,
  smallBeginWidth,
  largeScreenSmallBeginMidWidth,
}) => {
  return {
    'fullscreen-begin': {
      begin: {
        width: '100%',
        minWidth: '100%',
        zIndex: startzIndex + 1,
      },
      mid: {
        width: 0,
        minWidth: 0,
        zIndex: startzIndex,
      },
      end: {
        width: 0,
        minWidth: 0,
        zIndex: startzIndex,
      },
      split: {
        zIndex: startzIndex,
      },
    },
    'fullscreen-mid': {
      begin: {
        width: 0,
        minWidth: 0,
        zIndex: startzIndex,
      },
      mid: {
        width: '100%',
        minWidth: '100%',
        zIndex: startzIndex + 1,
      },
      end: {
        width: 0,
        minWidth: 0,
        zIndex: startzIndex,
      },
      split: {
        zIndex: startzIndex,
      },
    },
    'fullscreen-end': {
      begin: {
        width: 0,
        minWidth: 0,
        zIndex: startzIndex,
      },
      mid: {
        width: 0,
        minWidth: 0,
        zIndex: startzIndex,
      },
      end: {
        width: '100%',
        minWidth: '100%',
        zIndex: startzIndex + 1,
      },
      split: {
        zIndex: startzIndex,
      },
    },
    'large-begin': {
      begin: {
        width: largeBeginWidth,
        minWidth: largeBeginWidth,
        zIndex: startzIndex + 1,
      },
      mid: {
        width: largeScreenLargeBeginMidWidth,
        minWidth: largeScreenLargeBeginMidWidth,
        zIndex: startzIndex + 1,
      },
      end: {
        width: endFixedWidth,
        minWidth: endFixedWidth,
        zIndex: parseFloat(endFixedWidth) <= 0 ? startzIndex : startzIndex + 1,
        display: parseFloat(endFixedWidth) <= 0 ? 'none' : 'block',
      },
      split: {
        zIndex: startzIndex + 1,
      },
    },
    'small-begin': {
      begin: {
        width: smallBeginWidth,
        minWidth: smallBeginWidth,
        zIndex: startzIndex + 1,
      },
      mid: {
        width: largeScreenSmallBeginMidWidth,
        minWidth: largeScreenSmallBeginMidWidth,
        zIndex: startzIndex + 1,
      },
      end: {
        width: endFixedWidth,
        minWidth: endFixedWidth,
        zIndex: parseFloat(endFixedWidth) <= 0 ? startzIndex : startzIndex + 1,
        display: parseFloat(endFixedWidth) <= 0 ? 'none' : 'block',
      },
      split: {
        zIndex: startzIndex + 1,
      },
    },
  };
};

const doModesForSmallScreen = ({ startzIndex, smallScreenWithSplitWidth, endFixedWidth }) => {
  return {
    'fullscreen-begin': {
      begin: {
        width: '100%',
        minWidth: '100%',
        zIndex: startzIndex + 1,
      },
      mid: {
        width: 0,
        minWidth: 0,
        zIndex: startzIndex,
      },
      end: {
        width: 0,
        minWidth: 0,
        zIndex: startzIndex,
      },
      split: {
        zIndex: startzIndex,
      },
    },
    'fullscreen-mid': {
      begin: {
        width: 0,
        minWidth: 0,
        zIndex: startzIndex,
      },
      mid: {
        width: '100%',
        minWidth: '100%',
        zIndex: startzIndex + 1,
      },
      end: {
        width: 0,
        minWidth: 0,
        zIndex: startzIndex,
      },
      split: {
        zIndex: startzIndex,
      },
    },
    'fullscreen-end': {
      begin: {
        width: 0,
        minWidth: 0,
        zIndex: startzIndex,
      },
      mid: {
        width: 0,
        minWidth: 0,
        zIndex: startzIndex,
      },
      end: {
        width: '100%',
        minWidth: '100%',
        zIndex: startzIndex + 1,
      },
      split: {
        zIndex: startzIndex,
      },
    },
    'large-begin': {
      begin: {
        width: smallScreenWithSplitWidth,
        minWidth: smallScreenWithSplitWidth,
        zIndex: startzIndex + 1,
      },
      mid: {
        width: 0,
        minWidth: 0,
        zIndex: startzIndex,
      },
      end: {
        width: endFixedWidth,
        minWidth: endFixedWidth,
        zIndex: parseFloat(endFixedWidth) <= 0 ? startzIndex : startzIndex + 1,
        display: parseFloat(endFixedWidth) <= 0 ? 'none' : 'block',
      },
      split: {
        zIndex: startzIndex + 1,
      },
    },
    'small-begin': {
      begin: {
        width: 0,
        minWidth: 0,
        zIndex: startzIndex,
      },
      mid: {
        width: smallScreenWithSplitWidth,
        zIndex: startzIndex + 1,
      },
      end: {
        width: endFixedWidth,
        minWidth: endFixedWidth,
        zIndex: parseFloat(endFixedWidth) <= 0 ? startzIndex : startzIndex + 1,
        display: parseFloat(endFixedWidth) <= 0 ? 'none' : 'block',
      },
      split: {
        zIndex: startzIndex + 1,
      },
    },
  };
};

export const setStylesScreen = ({
  mode,
  startzIndex,
  largeScreenLargeBeginMidWidth,
  largeBeginWidth,
  endFixedWidth,
  smallBeginWidth,
  largeScreenSmallBeginMidWidth,
  smallScreenWithSplitWidth,
}) => {
  if (mode === 'modesForLargeScreen') {
    return doModesForLargeScreen({
      startzIndex,
      largeBeginWidth,
      largeScreenLargeBeginMidWidth,
      endFixedWidth,
      smallBeginWidth,
      largeScreenSmallBeginMidWidth,
    });
  } else if (mode === 'modesForSmallScreen') {
    return doModesForSmallScreen({ startzIndex, smallScreenWithSplitWidth, endFixedWidth });
  }
};
